<template>
  <VueDocPreview :value="docValue" :type="docType" />
</template>

<script>
import VueDocPreview from "vue-doc-preview";
export default {
  data: (vm) => ({
     docValue:
     //"# file://192.168.11.2/backup/deposito/rvelozo/varios/inventario/stock_deposito/reconectadores.xls",
    //"file\\192.168.11.2\backup\deposito\rvelozo\varios\inventario\stock_deposito\reconectadores.xls",
    "https://api.icssa.com.ar/extras/INVENTARIO/RECONECTADORES.xls",
    //"https://api.icssa.com.ar/extras/INVENTARIO/RECONECTADOR",

    docType: "office",
  }),
  components: {
    VueDocPreview,
  },
};
</script>
